import HeroSection from './components/HeroSection.js';
import FeaturedProjects from './components/FeaturedProjects.js';
import Testimonial from './components/Testimonial.js';
import FAQSection from './components/FAQSection.jsx';


const Home = () => {
 return (
    <>
         <HeroSection />
         <FeaturedProjects />
         <Testimonial />
         <FAQSection />
         

    </>
 );

}

export default Home;